import { MultiSelect } from '@mantine/core';
import { useFilterFormContext } from '@/pages/Statistics/StatisticsPage';

interface FormLocalityMultiSelectProps {
  localities: Locality[]
}

interface Locality {
  id: string;
  name: string;
}

const FormLocalityMultiSelect: React.FC<FormLocalityMultiSelectProps> = ({
  localities,
}) => {
  const form = useFilterFormContext();
  

  return (
    <MultiSelect
      label="Lokalita"
      data={localities.map(({id, name}) => ({
        value: id.toString(),
        label: name
      }))}
      value={(form.values.localityIds ?? []).map(String)}
      clearable
      onChange={selected =>
        form.setFieldValue(
          'localityIds',
          selected.length === 0 ? undefined : selected.map(Number)
        )
      }
    />
  );
};

export default FormLocalityMultiSelect;